import React, { CSSProperties, useEffect, useState } from 'react'

import { useEditor, useNode } from '@craftjs/core'
import { getStyle } from '../../services/HelperService'
import { TextProps } from '../../types/props'
import { useMediaQuery } from '@mui/material'
import { SupportedLanguage, useLanguage, useRecipient } from '../../contexts/RecipientContext'
import './Text.scss'
import { getTextOutline } from '.'

export const Text = (textProps: TextProps) => {
  const {query: {node}} = useEditor()
  const {parent} = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dom: state.dom,
    parent: state.data.parent
  }))
  const mobile = useMediaQuery('(max-width:500px)')
  const {variables}: any = useRecipient()
  const {language, defaultLanguage}: {language: SupportedLanguage, defaultLanguage: SupportedLanguage} = useLanguage()
  const addFontTag = () => {
    if (!['MuseoSans', 'CeraPro', 'Arial Narrow', 'MinionPro', 'Roboto Condensed', 'TTSlu', 'Whyte', 'Barlow', 'Barlow Medium', 'DSG Sans Medium', 'DSG Sans Black', 'Genesis Sans Head Light', 'Genesis Sans Head', 'Genesis Sans Text', 'Genesis Sans Text Medium', 'Copperplate'].includes(textProps.style.fontFamily)) {
      let style = document.createElement('style')
      style.innerHTML = `@import url('https://fonts.googleapis.com/css2?family=${textProps.style.fontFamily.replace(/\s/g, '+')}:ital,wght@0,400;0,700;1,400;1,700&display=swap');`
      document.head.appendChild(style)
    }
  }
  const [customHTML, setCustomHTML] = useState<string>('')

  let parentNode = node(parent).get()
  let style: CSSProperties = {
    maxHeight: '100%',
    position: 'relative',
    ...textProps.style,
    ...getStyle(textProps.style, textProps.mobileStyle, parentNode, mobile),
    ...getTextOutline(textProps)
  }

  const shouldRenderText = Boolean(textProps.html ?? textProps[language]?.html ?? textProps['US']?.html ?? (textProps as any)[""]?.html);

  useEffect(() => {
    addFontTag()
  }, [])

  useEffect(() => {
    if (variables && shouldRenderText) {
      let new_html: string = String(textProps[language]?.html ?? textProps['US']?.html ?? textProps.html ??  (textProps as any)[""]?.html ?? '<></>'); // fallback, Some landing pages are saved with "" keyword but new landing page will remove this automatically at first render

      // if (!textProps.language_specific || language === defaultLanguage || !textProps[language]?.html) {
      //   new_html = textProps.html || '<></>'
      // } else {
      //   new_html = textProps[language]?.html
      // }

      new_html = new_html.replaceAll(/({{)(.*?)(}})/g, (match: string, offset: number) => {
        const key = match.substring(2, match.length - 2)

        return variables[key] ?? ''
      })

      setCustomHTML(new_html)
    }
  }, [variables, language])

  return <div className="dm-edit-text"
    style={style}>
    {
      shouldRenderText &&
      <div dangerouslySetInnerHTML={{__html: customHTML}}>
      </div> 
    }
  </div>
}

Text.craft = {
  displayName: 'Text'
}
